/**************************************************
 * Nombre:       Home_Actividades
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    EmojiNatureOutlined,
    HikingOutlined,
    HotTubOutlined,
    SpaOutlined,
    WaterOutlined,
    WavesOutlined
} from '@mui/icons-material'
import Tarjetas_Actividades from "../../Tarjetas/Tarjetas_Actividades";
import fondo from '../../../Recursos/fondo_actividades.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Actividades = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'left',
                backgroundRepeat: 'no-repeat',
                pb: 16
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{
                                    fontSize: sCell ? 32 : 48,
                                    fontWeight: 800,
                                    fontFamily: 'Raleway',
                                    textAlign: 'center',
                                    lineHeight: 1.1
                                }}>
                                Experiencias Para Vivir
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={ !masSM ? 4 :8}
                            >

                                {actividades.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjetas_Actividades item={it} index={index}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Actividades

const actividades = [
    {
        icono: HikingOutlined,
        nombre: 'Senderos Naturales',
        descripcion: 'Recorre caminos rodeados de vegetación exuberante y descubre la magia de la flora y fauna local.'
    },
    {
        icono: EmojiNatureOutlined,
        nombre: 'Observación De Vida Silvestre',
        descripcion: 'Vive encuentros únicos con aves y mamíferos en su hábitat natural, un espectáculo inolvidable.'
    }, {
        icono: SpaOutlined,
        nombre: 'Spa',
        descripcion: 'Disfruta de masajes y tratamientos que renuevan cuerpo y alma, inspirados en  la naturaleza.'
    },
    {
        icono: WaterOutlined,
        nombre: 'Ríos y Cascadas',
        descripcion: 'relájate con el murmullo del agua o sumérgete en refrescantes pozas cristalinas'
    },
    {
        icono: HotTubOutlined,
        nombre: 'Jacuzzi',
        descripcion: 'Relájate en nuestro jacuzzi y disfruta la calma de la naturaleza'
    },

]